module.exports = __webpack_public_path__ + "static/media/awards.d7b62a5d.jpg";